"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaContexteConsumer = exports.MfaContexteProvider = exports.MfaContexteProviderBase = exports.MfaContexte = void 0;

var _react = _interopRequireWildcard(require("react"));

var _queryString = _interopRequireDefault(require("query-string"));

var _reactRouter = require("react-router");

var _MfaEnvironnement = require("../commun/MfaEnvironnement");

var _utilitaires = require("../utils/utilitaires");

var _utilitaires2 = require("../utils/utilitaires.requete");

var _MfaDialogue = require("./MfaDialogue");

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaContexte = /*#__PURE__*/_react.default.createContext();

exports.MfaContexte = MfaContexte;

var MfaContexteProviderBase = /*#__PURE__*/function (_Component) {
  _inherits(MfaContexteProviderBase, _Component);

  var _super = _createSuper(MfaContexteProviderBase);

  function MfaContexteProviderBase(props) {
    var _this;

    _classCallCheck(this, MfaContexteProviderBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "erreurContexte", void 0);

    _this.mettreAjourVariable = _this.mettreAjourVariable.bind(_assertThisInitialized(_this));
    _this.state = {
      noDivision: null,
      contexteSAI: null,
      environnement: null,
      acces: null,
      role: null,
      division: null,
      mettreAjourVariable: _this.mettreAjourVariable,
      enDeveloppement: false,
      messageErreur: null,
      proprietes: MfaContexteProviderBase.extraireProprietes(_this.props),
      authentifier: false,
      dictionnaireComportement: null,
      listeAcces: null,
      messageAuthenticationEchoue: "Impossible de poursuivre les opérations car votre authentification est invalide.",
      messageSortie: "Retour au DSG"
    };
    _this.erreurContexte = {
      environnementEchoue: _this.obtenirCallbackErreur("Impossible d'obtenir l'information sur l'environnement"),
      environnementObjetEchoue: _this.obtenirCallbackErreur("L'information obtenu sur l'environnement est invalide"),
      intranetEchoue: _this.obtenirCallbackErreur("Impossible d'authentifier l'utilisateur intranet"),
      intranetObjetEchoue: _this.obtenirCallbackErreur("L'authentification intranet est invalide"),
      contextEchoue: _this.obtenirCallbackErreur("Impossible d'obtenir l'information sur le contexte"),
      contextObjetEchoue: _this.obtenirCallbackErreur("L'information obtenu sur le contexte est invalide"),
      contextTestEchoue: _this.obtenirCallbackErreur("Impossible d'obtenir le contexte test"),
      contextTestObjetEchoue: _this.obtenirCallbackErreur("L'information obtenu sur le contexte test est invalide"),
      extranetEchoue: _this.obtenirCallbackErreur("Impossible d'authentifier l'utilisateur extranet"),
      extranetObjetEchoue: _this.obtenirCallbackErreur("L'authentification extranet est invalide")
    };
    return _this;
  }

  _createClass(MfaContexteProviderBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.authentication();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var authentifier = this.state.authentifier;

      if (authentifier) {
        this.authentifier = false;
        this.setState({
          acces: null,
          authentifier: false
        }, function () {
          _this2.authentication();
        });
      }
    }
  }, {
    key: "mettreAjourVariable",
    value: function mettreAjourVariable(nom, valeur) {
      var variablesGlobales = this.props.variablesGlobales;

      if (!(0, _utilitaires.estDefini)(variablesGlobales) || !(0, _utilitaires.estDefini)(variablesGlobales.find(function (variable) {
        return (0, _utilitaires.estDefini)(variable, 'nom') && variable.nom === nom;
      }))) {
        return;
      }

      var etat = {};
      etat[nom] = valeur;
      this.setState(etat);
    }
  }, {
    key: "obtenirMessageSortie",
    value: function obtenirMessageSortie() {
      var messageSortie = this.props.messageSortie;
      return (0, _utilitaires.estDefini)(messageSortie) ? messageSortie : this.state.messageSortie;
    }
  }, {
    key: "surSortie",
    value: function surSortie() {
      var adresseSortie = this.state.adresseSortie;
      window.location.href = adresseSortie;
    }
  }, {
    key: "renderDialogue",
    value: function renderDialogue(afficher, titre, information, nomIcone) {
      return /*#__PURE__*/_react.default.createElement(_MfaDialogue.MfaDialogue, {
        estVisible: afficher,
        surSortie: this.surSortie.bind(this),
        titre: titre,
        tailleIcone: "xl",
        couleurIcone: "red",
        nomIcone: nomIcone,
        messageboutonSortie: this.obtenirMessageSortie()
      }, /*#__PURE__*/_react.default.createElement("b", null, information));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          acces = _this$state.acces,
          messageErreur = _this$state.messageErreur,
          etatDialogueAuthentication = _this$state.etatDialogueAuthentication;

      if ((0, _utilitaires.estDefini)(messageErreur)) {
        return this.renderDialogue(true, "Authentification en erreur", messageErreur);
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, acces === true ? /*#__PURE__*/_react.default.createElement(MfaContexte.Provider, {
        value: _objectSpread({
          afficherDialogueAuthentication: this.afficherDialogueAuthenticationEchoue.bind(this)
        }, this.state)
      }, this.props.children) : acces === false ? this.renderDialogue(!acces, "Autorisation d'accès", "Vous n'êtes pas autorisé à accéder à l'application.", 'minus circle') : /*#__PURE__*/_react.default.createElement("b", null, "Chargement en cours. Veuillez patienter... "), etatDialogueAuthentication === true && this.renderDialogue(etatDialogueAuthentication, "Authentification échoué", this.state.messageAuthenticationEchoue, 'lock'));
    }
  }, {
    key: "afficherDialogueAuthenticationEchoue",
    value: function afficherDialogueAuthenticationEchoue() {
      this.setState({
        etatDialogueAuthentication: true
      });
    }
  }, {
    key: "obtenirCallbackErreur",
    value: function obtenirCallbackErreur(messageErreur) {
      var _this3 = this;

      return function () {
        return _this3.setState({
          messageErreur: messageErreur,
          etatDialogueAuthentication: true
        });
      };
    }
  }, {
    key: "authentication",
    value: function () {
      var _authentication = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var adresseEnvironnement, _this$erreurContexte, environnementEchoue, environnementObjetEchoue, requete, contexteSAI, donneeApp, environnement, enDeveloppement, urlPortail;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                adresseEnvironnement = this.props.adresseEnvironnement;
                _this$erreurContexte = this.erreurContexte, environnementEchoue = _this$erreurContexte.environnementEchoue, environnementObjetEchoue = _this$erreurContexte.environnementObjetEchoue;
                requete = _queryString.default.parse(this.props.location.search);
                contexteSAI = requete.contexteSAI;

                if (!(0, _utilitaires.estDefini)(contexteSAI)) {
                  contexteSAI = this.obtenirContexteSAISauvegarde();
                }

                _context.next = 7;
                return (0, _utilitaires2.requeteGerer)(adresseEnvironnement, environnementEchoue, environnementObjetEchoue, contexteSAI);

              case 7:
                donneeApp = _context.sent;

                if ((0, _utilitaires.estDefini)(donneeApp)) {
                  _context.next = 11;
                  break;
                }

                this.setState({
                  messageErreur: "Aucune information d'authentication"
                });
                return _context.abrupt("return");

              case 11:
                environnement = donneeApp.environnement, enDeveloppement = donneeApp.enDeveloppement, urlPortail = donneeApp.urlPortail;

                if (this.verifierEnvironnement(environnement)) {
                  _context.next = 17;
                  break;
                }

                this.setState({
                  messageErreur: 'Environnement inconnu'
                });
                return _context.abrupt("return");

              case 17:
                if (environnement === _MfaEnvironnement.MfaEnvironnement.Intranet) {
                  this.authenticationIntranet(enDeveloppement);
                } else if (environnement === _MfaEnvironnement.MfaEnvironnement.Extranet) {
                  this.authenticationExtranet(enDeveloppement, urlPortail);
                }

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authentication() {
        return _authentication.apply(this, arguments);
      }

      return authentication;
    }()
  }, {
    key: "authenticationIntranet",
    value: function () {
      var _authenticationIntranet = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(enDeveloppement) {
        var _this$props, adresseAuthentication, adresseAccesComposantes, adresseContexteTest, adresseDechiffrerContexte, _this$erreurContexte2, intranetEchoue, intranetObjetEchoue, contextTestEchoue, contextTestObjetEchoue, contextEchoue, contextObjetEchoue, requete, contexteSAI, optionsAuthentication, authentication, contexte, blocsApplicatifs;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = this.props, adresseAuthentication = _this$props.adresseAuthentication, adresseAccesComposantes = _this$props.adresseAccesComposantes, adresseContexteTest = _this$props.adresseContexteTest, adresseDechiffrerContexte = _this$props.adresseDechiffrerContexte;
                _this$erreurContexte2 = this.erreurContexte, intranetEchoue = _this$erreurContexte2.intranetEchoue, intranetObjetEchoue = _this$erreurContexte2.intranetObjetEchoue, contextTestEchoue = _this$erreurContexte2.contextTestEchoue, contextTestObjetEchoue = _this$erreurContexte2.contextTestObjetEchoue, contextEchoue = _this$erreurContexte2.contextEchoue, contextObjetEchoue = _this$erreurContexte2.contextObjetEchoue;
                requete = _queryString.default.parse(this.props.location.search);
                contexteSAI = requete.contexteSAI;

                if (!(!(0, _utilitaires.estDefini)(contexteSAI) && adresseContexteTest && enDeveloppement === true)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return (0, _utilitaires2.requeteGerer)(adresseContexteTest, contextTestEchoue, contextTestObjetEchoue, null, 'text');

              case 7:
                contexteSAI = _context2.sent;

              case 8:
                optionsAuthentication = this.obtenirOptionsAuthentication(contexteSAI);
                _context2.next = 11;
                return (0, _utilitaires2.requeteGerer)(adresseAuthentication, intranetEchoue, intranetObjetEchoue, contexteSAI, 'json', optionsAuthentication);

              case 11:
                authentication = _context2.sent;

                if ((0, _utilitaires.estDefini)(authentication)) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return");

              case 14:
                _context2.next = 16;
                return (0, _utilitaires2.requeteGerer)(adresseDechiffrerContexte, contextEchoue, contextObjetEchoue, contexteSAI, 'json', optionsAuthentication);

              case 16:
                contexte = _context2.sent;

                if ((0, _utilitaires.estDefini)(contexte)) {
                  _context2.next = 19;
                  break;
                }

                return _context2.abrupt("return");

              case 19:
                blocsApplicatifs = contexte.blocsApplicatifs;
                this.setState({
                  contexteSAI: authentication.contexteSAI,
                  environnement: authentication.environnement,
                  acces: authentication.acces ? !(0, _utilitaires.estDefini)(adresseAccesComposantes) ? true : null : false,
                  blocsApplicatifs: (0, _utilitaires.estDefini)(blocsApplicatifs) ? blocsApplicatifs.split(';') : [],
                  role: authentication.role
                }, authentication.acces ? this.chargerComportement.bind(this) : null);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function authenticationIntranet(_x) {
        return _authenticationIntranet.apply(this, arguments);
      }

      return authenticationIntranet;
    }()
  }, {
    key: "sauvegarderEtat",
    value: function sauvegarderEtat() {
      sessionStorage.setItem("contextePES", JSON.stringify(this.state));
    }
  }, {
    key: "chargerEtat",
    value: function chargerEtat() {
      var etatSauvegarde = this.obtenirEtatSauvegarde();

      if (!(0, _utilitaires.estDefini)(etatSauvegarde)) {
        return false;
      }

      this.setState(etatSauvegarde);
      return true;
    }
  }, {
    key: "obtenirEtatSauvegarde",
    value: function obtenirEtatSauvegarde() {
      var etatSauvegarde = sessionStorage.getItem("contextePES");

      if (!(0, _utilitaires.estDefini)(etatSauvegarde)) {
        return null;
      }

      var objetEtat;

      try {
        objetEtat = JSON.parse(etatSauvegarde);
      } catch (e) {
        return null;
      }

      if (!(0, _utilitaires.estDefini)(objetEtat, 'contexteSAI', 'environnement', 'blocsApplicatifs')) {
        return null;
      }

      return objetEtat;
    }
  }, {
    key: "obtenirContexteSAISauvegarde",
    value: function obtenirContexteSAISauvegarde() {
      var etat = this.obtenirEtatSauvegarde();

      if ((0, _utilitaires.estDefini)(etat, 'contexteSAI')) {
        return etat.contexteSAI;
      }

      return null;
    }
  }, {
    key: "chargerVariablesGlobales",
    value: function () {
      var _chargerVariablesGlobales = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var _this$props2, variablesGlobales, adresseObtenirAdresseSortie, listeRequetes, etat, nomsReserves, variable, type, nom, reponse, objet;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props2 = this.props, variablesGlobales = _this$props2.variablesGlobales, adresseObtenirAdresseSortie = _this$props2.adresseObtenirAdresseSortie;

                if (!(!(0, _utilitaires.estDefini)(variablesGlobales) && !(0, _utilitaires.estDefini)(adresseObtenirAdresseSortie))) {
                  _context3.next = 4;
                  break;
                }

                this.setState({
                  acces: true
                }, function () {
                  return _this4.sauvegarderEtat();
                });
                return _context3.abrupt("return");

              case 4:
                if (!(0, _utilitaires.estDefini)(variablesGlobales)) {
                  variablesGlobales = [];
                }

                if ((0, _utilitaires.estDefini)(adresseObtenirAdresseSortie) && !variablesGlobales.some(function (variable) {
                  return variable.nom === 'adresseSortie';
                })) {
                  variablesGlobales.push({
                    type: 'text',
                    nom: 'adresseSortie',
                    adresse: adresseObtenirAdresseSortie
                  });
                }

                variablesGlobales = variablesGlobales instanceof Array ? variablesGlobales : [variablesGlobales];
                listeRequetes = [];
                variablesGlobales.forEach(function (variableGlobale) {
                  var adresse = variableGlobale.adresse,
                      nom = variableGlobale.nom,
                      type = variableGlobale.type,
                      environnement = variableGlobale.environnement;

                  if ((0, _utilitaires.estDefini)(environnement) && environnement !== _this4.state.environnement) {
                    return;
                  }

                  listeRequetes.push({
                    type: type,
                    nom: nom,
                    requete: (0, _utilitaires2.requete)(adresse, _this4.state)
                  });
                });
                etat = {};
                etat.valid = true;
                nomsReserves = Object.keys(this.state);

              case 12:
                if (!(listeRequetes.length > 0)) {
                  _context3.next = 29;
                  break;
                }

                variable = listeRequetes.shift();
                type = variable.type, nom = variable.nom;

                while (nomsReserves.indexOf(nom) != -1) {
                  nom = "_".concat(nom);
                }

                nomsReserves.push(nom);
                _context3.next = 19;
                return variable.requete;

              case 19:
                reponse = _context3.sent;

                if (!(reponse.status !== 200)) {
                  _context3.next = 23;
                  break;
                }

                etat.valid = false;
                return _context3.abrupt("break", 29);

              case 23:
                _context3.next = 25;
                return reponse[(0, _utilitaires.estDefini)(type) ? type : 'json']();

              case 25:
                objet = _context3.sent;
                etat[nom] = objet;
                _context3.next = 12;
                break;

              case 29:
                if (!etat.valid) {
                  etat.acces = false;
                } else {
                  etat.acces = true;
                }

                this.setState(etat, function () {
                  return _this4.sauvegarderEtat();
                });

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function chargerVariablesGlobales() {
        return _chargerVariablesGlobales.apply(this, arguments);
      }

      return chargerVariablesGlobales;
    }()
  }, {
    key: "chargerComportement",
    value: function () {
      var _chargerComportement = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this$props3, adresseComportement, adresseAccesComposantes, requeteAcces, dictionnaireComportement, reponseComportements, reponseAcces, listeAcces;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props3 = this.props, adresseComportement = _this$props3.adresseComportement, adresseAccesComposantes = _this$props3.adresseAccesComposantes;

                if ((0, _utilitaires.estDefini)(adresseAccesComposantes)) {
                  _context4.next = 4;
                  break;
                }

                this.setState({}, this.chargerVariablesGlobales.bind(this));
                return _context4.abrupt("return");

              case 4:
                requeteAcces = (0, _utilitaires2.requete)(adresseAccesComposantes, this.state);
                dictionnaireComportement = null;

                if (!(0, _utilitaires.estDefini)(adresseComportement)) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 9;
                return (0, _utilitaires2.requete)(adresseComportement, this.state);

              case 9:
                reponseComportements = _context4.sent;
                _context4.next = 12;
                return reponseComportements.json();

              case 12:
                dictionnaireComportement = _context4.sent;

              case 13:
                _context4.next = 15;
                return requeteAcces;

              case 15:
                reponseAcces = _context4.sent;
                _context4.next = 18;
                return reponseAcces.json();

              case 18:
                listeAcces = _context4.sent;
                this.setState({
                  listeAcces: listeAcces,
                  dictionnaireComportement: dictionnaireComportement
                }, this.chargerVariablesGlobales.bind(this));

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function chargerComportement() {
        return _chargerComportement.apply(this, arguments);
      }

      return chargerComportement;
    }()
  }, {
    key: "obtenirOptionsAuthentication",
    value: function obtenirOptionsAuthentication(contexteSAI) {
      return {
        headers: {
          'Authentication': contexteSAI
        }
      };
    }
  }, {
    key: "authenticationExtranet",
    value: function () {
      var _authenticationExtranet = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(enDeveloppement, urlPortail) {
        var _this$props4, adresseAuthentication, adresseContexteTest, adresseDechiffrerContexte, adresseAccesComposantes, _this$erreurContexte3, contextEchoue, contextObjetEchoue, contextTestEchoue, contextTestObjetEchoue, extranetEchoue, extranetObjetEchoue, requete, contexteSAI, optionsAuthentication, contexte, authentication, blocsApplicatifs, division;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$props4 = this.props, adresseAuthentication = _this$props4.adresseAuthentication, adresseContexteTest = _this$props4.adresseContexteTest, adresseDechiffrerContexte = _this$props4.adresseDechiffrerContexte, adresseAccesComposantes = _this$props4.adresseAccesComposantes;
                _this$erreurContexte3 = this.erreurContexte, contextEchoue = _this$erreurContexte3.contextEchoue, contextObjetEchoue = _this$erreurContexte3.contextObjetEchoue, contextTestEchoue = _this$erreurContexte3.contextTestEchoue, contextTestObjetEchoue = _this$erreurContexte3.contextTestObjetEchoue, extranetEchoue = _this$erreurContexte3.extranetEchoue, extranetObjetEchoue = _this$erreurContexte3.extranetObjetEchoue;
                requete = _queryString.default.parse(this.props.location.search);
                contexteSAI = requete.contexteSAI;

                if (!(!(0, _utilitaires.estDefini)(contexteSAI) && adresseContexteTest && enDeveloppement === true)) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 7;
                return (0, _utilitaires2.requeteGerer)(adresseContexteTest, contextTestEchoue, contextTestObjetEchoue, null, 'text');

              case 7:
                contexteSAI = _context5.sent;

              case 8:
                if ((0, _utilitaires.estDefini)(contexteSAI)) {
                  _context5.next = 12;
                  break;
                }

                if (!this.chargerEtat()) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return");

              case 11:
                return _context5.abrupt("return");

              case 12:
                optionsAuthentication = this.obtenirOptionsAuthentication(contexteSAI);
                _context5.next = 15;
                return (0, _utilitaires2.requeteGerer)(adresseDechiffrerContexte, contextEchoue, contextObjetEchoue, contexteSAI, 'json', optionsAuthentication);

              case 15:
                contexte = _context5.sent;

                if ((0, _utilitaires.estDefini)(contexte)) {
                  _context5.next = 18;
                  break;
                }

                return _context5.abrupt("return");

              case 18:
                _context5.next = 20;
                return (0, _utilitaires2.requeteGerer)(adresseAuthentication, extranetEchoue, extranetObjetEchoue, contexteSAI, 'json', optionsAuthentication);

              case 20:
                authentication = _context5.sent;

                if ((0, _utilitaires.estDefini)(authentication)) {
                  _context5.next = 23;
                  break;
                }

                return _context5.abrupt("return");

              case 23:
                blocsApplicatifs = contexte.blocsApplicatifs;
                division = {
                  numDivision: contexte.noDivision,
                  nomDivision: contexte.nomDivision,
                  typeDivision: contexte.typeDivision,
                  blocsApplicatifs: (0, _utilitaires.estDefini)(blocsApplicatifs) ? blocsApplicatifs.split(';') : []
                };
                this.setState({
                  environnement: authentication.environnement,
                  noDivision: contexte.noDivision,
                  division: division,
                  acces: authentication.acces ? !(0, _utilitaires.estDefini)(adresseAccesComposantes) ? true : null : false,
                  contexteSAI: contexteSAI,
                  enDeveloppement: enDeveloppement,
                  urlPortail: urlPortail,
                  blocsApplicatifs: division.blocsApplicatifs,
                  messageErreur: null
                }, authentication.acces ? this.chargerComportement.bind(this) : null);

              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function authenticationExtranet(_x2, _x3) {
        return _authenticationExtranet.apply(this, arguments);
      }

      return authenticationExtranet;
    }()
  }, {
    key: "verifierEnvironnement",
    value: function verifierEnvironnement(environnement) {
      if (!Object.keys(_MfaEnvironnement.MfaEnvironnement).some(function (env) {
        return env === environnement;
      })) {
        return false;
      }

      return true;
    }
  }], [{
    key: "extraireProprietes",
    value: function extraireProprietes(objetPropriete) {
      if (!(0, _utilitaires.estDefini)(objetPropriete)) {
        return {};
      }

      return MfaContexteProviderBase.nomsProprietes.reduce(function (proprietes, nomPropriete) {
        proprietes[nomPropriete] = objetPropriete[nomPropriete];
        return proprietes;
      }, {});
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(procahineProps, etatPrecedent) {
      var proprietes = etatPrecedent.proprietes;
      var prochaineProprietes = MfaContexteProviderBase.extraireProprietes(procahineProps);
      var authentifier = !(0, _utilitaires.objetsEgaux)(proprietes, prochaineProprietes);

      if (authentifier === true) {
        return {
          proprietes: prochaineProprietes,
          authentifier: authentifier
        };
      }

      return null;
    }
  }]);

  return MfaContexteProviderBase;
}(_react.Component);

exports.MfaContexteProviderBase = MfaContexteProviderBase;

_defineProperty(MfaContexteProviderBase, "displayName", MfaContexteProviderBase.name);

_defineProperty(MfaContexteProviderBase, "nomsProprietes", ['adresseAuthentication', 'adresseEnvironnement', 'adresseDechiffrerContexte', 'adresseContexteTest']);

var MfaContexteProvider = (0, _reactRouter.withRouter)(MfaContexteProviderBase);
exports.MfaContexteProvider = MfaContexteProvider;
var MfaContexteConsumer = MfaContexte.Consumer;
exports.MfaContexteConsumer = MfaContexteConsumer;